<template>
    <b-modal
        id="ModalUpdateCronjob"
        title="Modifier une tâche programmée"
        header-bg-variant="kalkin-1"
        header-text-variant="light"
        size="xl"
        hide-footer
    >
        <FormCronjob :cronjob="cronjob" @saved="onSaved" />
    </b-modal>
</template>
<script>
import FormCronjob from "./FormCronjob";
export default {
    components: {
        FormCronjob,
    },

    props: {
        cronjob: { type: Object, required: true },
    },

    methods: {
        onSaved() {
            this.$bvModal.hide("ModalUpdateCronjob");
            this.$emit("saved");
        },
    },
};
</script>
